var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_458_29681",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.69281 1.31075L2.05153 0.631143L16.2637 1.15689L15.9818 13.464L13.5941 14.6474L0.574951 13.8336L0.69281 1.31075Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_458_29681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0401 1.95841L14.7901 4.33341V13.8334L10.0401 11.4584L6.08179 13.0417L1.33179 10.6667V1.16675L6.08179 3.54175L10.0401 1.95841Z",
    stroke: "white",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.04 11.4583V1.95825",
    stroke: "white",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08154 3.5415V13.0415",
    stroke: "white",
    strokeWidth: 0.9
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapWhite);
export default __webpack_public_path__ + "static/media/map-white.50150691e7782cf030d43a79a0a053e1.svg";
export { ForwardRef as ReactComponent };